import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ChatModule } from '@tytapp/chat';
import { TYTCommonModule } from "@tytapp/common";
import { CommonUiModule } from "@tytapp/common-ui";
import { ArticleItemViewComponent } from './article-item-view/article-item-view.component';
import { ArticleViewComponent } from "./article-view/article-view.component";

const COMPONENTS = [
    ArticleViewComponent,
    ArticleItemViewComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        CommonUiModule,
        TYTCommonModule,
        RouterModule,
        FormsModule,
        ChatModule
    ],
    exports: COMPONENTS
})
export class ArticlesModule {
    static forRoot(): ModuleWithProviders<ArticlesModule> {
        return {
            providers: [],
            ngModule: ArticlesModule
        }
    }
}